const LocationReviewsData = [
  {
    "customer": "Michael S.",
    "review": "Exceptional service! The team was punctual, friendly, and thoroughly repaired my roof. I noticed no more leaks right away.",
    "service": "Roof Repair"
  },
  {
    "customer": "Jessica T.",
    "review": "AttiAir exceeded my expectations. They repaired my roof quickly, and I can already feel the difference in insulation. Highly recommend!",
    "service": "Roof Repair"
  },
  {
    "customer": "Emily R.",
    "review": "Great experience from start to finish. The techs were knowledgeable, explained the process, and left everything spotless after repairing my roof.",
    "service": "Roof Repair"
  },
  {
    "customer": "Anthony J.",
    "review": "Efficient, professional, and reliable. I appreciate how the team paid attention to every detail during the roof repair. My home feels safer.",
    "service": "Roof Repair"
  },
  {
    "customer": "Robert K.",
    "review": "Quick response time and thorough roof repair. I'm finally leak-free, and it’s all thanks to AttiAir.",
    "service": "Roof Repair"
  },
  {
    "customer": "Sarah P.",
    "review": "They did an amazing job with my roof repair. The team was respectful of my property and got the job done quickly.",
    "service": "Roof Repair"
  },
  {
    "customer": "Lisa M.",
    "review": "Very impressed with the quality of service. The technicians were polite and took care of everything efficiently during the roof repair.",
    "service": "Roof Repair"
  },
  {
    "customer": "Kevin H.",
    "review": "AttiAir provided excellent service, and I noticed no more leaks immediately after the roof repair.",
    "service": "Roof Repair"
  },
  {
    "customer": "Diana F.",
    "review": "This was my first time using them, and I’ll definitely call again. Great value and fantastic results on my roof repair.",
    "service": "Roof Repair"
  },
  {
    "customer": "Eric W.",
    "review": "The technicians were professional and completed the roof repair quickly. My home is much more secure now.",
    "service": "Roof Repair"
  },
  {
    "customer": "Samantha L.",
    "review": "The team did a fantastic job fixing a leak in my roof. It was long overdue, and now the roof is working much better!",
    "service": "Roof Repair"
  },
  {
    "customer": "Tom C.",
    "review": "AttiAir saved us from further roof damage by thoroughly repairing a leak. Very grateful!",
    "service": "Roof Repair"
  },
  {
    "customer": "Olivia N.",
    "review": "Highly recommend their roof repair service. They arrived on time and finished the job without any mess.",
    "service": "Roof Repair"
  },
  {
    "customer": "Jason B.",
    "review": "I could tell they knew exactly what they were doing. My roof is now leak-free thanks to their excellent service.",
    "service": "Roof Repair"
  },
  {
    "customer": "Maria S.",
    "review": "AttiAir did an amazing job repairing my roof. I never realized how much damage had been accumulating over time!",
    "service": "Roof Repair"
  },
  {
    "customer": "Peter V.",
    "review": "Quick, efficient, and friendly service. I’ll be scheduling regular roof inspections and repairs with them.",
    "service": "Roof Repair"
  },
  {
    "customer": "Vanessa D.",
    "review": "Outstanding service! The techs were knowledgeable and explained the importance of regular roof maintenance and repairs.",
    "service": "Roof Repair"
  },
  {
    "customer": "Ben A.",
    "review": "I had a significant leak in my roof, but AttiAir handled it well. Great job with the repair!",
    "service": "Roof Repair"
  },
  {
    "customer": "Amy G.",
    "review": "They were able to schedule me quickly and did a thorough job repairing my roof. I appreciate their attention to detail.",
    "service": "Roof Repair"
  },
  {
    "customer": "Rachel K.",
    "review": "Very pleased with the roof repair. The team was professional, and I can already tell the difference in the stability of my roof.",
    "service": "Roof Repair"
  },
  {
    "customer": "Alex P.",
    "review": "The team found and fixed a leak in my roof that I didn't even know existed. Great service!",
    "service": "Roof Repair"
  },
  {
    "customer": "Brandon L.",
    "review": "Had a roof repair done, and they did an excellent job. The roof is now strong and leak-free.",
    "service": "Roof Repair"
  },
  {
    "customer": "Nina J.",
    "review": "They quickly identified and fixed the issue with my roof. I’m very happy with the results.",
    "service": "Roof Repair"
  },
  {
    "customer": "Trevor M.",
    "review": "AttiAir repaired a leak in my roof. It’s working much better now, and I’m very satisfied with the results.",
    "service": "Roof Repair"
  },
  {
    "customer": "Katie W.",
    "review": "The team was able to repair some damaged shingles and improve our home's roof quality. Highly recommend.",
    "service": "Roof Repair"
  },
  {
    "customer": "Chris B.",
    "review": "The technicians did a thorough inspection and fixed some roof issues we weren't aware of. Great job!",
    "service": "Roof Repair"
  },
  {
    "customer": "Megan R.",
    "review": "Very satisfied with their service. They identified and repaired some leaks in my roof system.",
    "service": "Roof Repair"
  },
  {
    "customer": "Danny H.",
    "review": "The roof repair work was quick, and the results were excellent. I appreciate their professionalism.",
    "service": "Roof Repair"
  },
  {
    "customer": "Lauren T.",
    "review": "AttiAir did a wonderful job repairing my roof. The leak is gone, and the roof is now secure.",
    "service": "Roof Repair"
  },
  {
    "customer": "Rick A.",
    "review": "They were able to repair the issues in my roof promptly. I’m very pleased with their service.",
    "service": "Roof Repair"
  },
  {
    "customer": "Ashley E.",
    "review": "The techs were professional and repaired the roof efficiently. Our home feels more comfortable now.",
    "service": "Roof Repair"
  },
  {
    "customer": "Monica G.",
    "review": "The team was able to fix a leak in my roof that was affecting the air quality in my home. Great job!",
    "service": "Roof Repair"
  },
  {
    "customer": "Hank F.",
    "review": "I was impressed by their thorough inspection and repair work. They really know what they're doing with roof repairs.",
    "service": "Roof Repair"
  },
  {
    "customer": "Jasmine K.",
    "review": "AttiAir repaired my roof and also fixed a few issues with insulation. The service was fantastic, and the results are noticeable.",
    "service": "Roof Repair"
  }
]
  
export default LocationReviewsData;
